/**
 * The brand colours the PrimeVue preset is built from (`src/main.ts`).
 *
 * One module so the design system (`docs/design-system/tokens.css`, read by
 * people and by Claude when they draw a mockup) can be checked against the
 * values the app actually renders: `designSystemTokens.test.ts` regenerates
 * each scale with PrimeVue's own `palette()` and fails on any drift.
 */
export const BRAND_COLORS = {
  /** Indigo. Semantic `primary`. */
  primary: '#380099',
  /** Turquoise. Semantic `info`. */
  info: '#74f2ce',
  /** Orange. Semantic `warn`. */
  warn: '#fbbe5e',
} as const
